// Vector shapes (circle, triangle, star, rectangle, diamond). No text inside.
// Background around the shape stays transparent (no wrapper background).
const STAR = "50,2 61.17,34.63 95.65,35.17 68.07,55.87 78.21,88.83 50,69 21.79,88.83 31.93,55.87 4.35,35.17 38.83,34.63";
const DIAMOND = "50,2 98,50 50,98 2,50";

function toRgba(hex, opacityPct) {
  const a = (opacityPct ?? 50) / 100;
  if (!hex) return `rgba(0,0,0,${a})`;
  if (hex.startsWith("rgb")) return hex;
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${a})`;
}

export function ShapeElement({ el }) {
  const s = el.estilo || {};
  const fill = s.fillColor || "#007AFF";
  const sw = Number(s.strokeWidth) || 0;
  const stroke = s.strokeColor || "#000000";
  // drop-shadow segue o formato real da forma (respeita transparência ao redor).
  const filter = s.shadowEnabled
    ? `drop-shadow(${Number(s.shadowX) || 0}px ${Number(s.shadowY) || 0}px ${Number(s.shadowBlur) || 0}px ${toRgba(s.shadowColor || "#000000", s.shadowOpacity ?? 50)})`
    : undefined;

  // Rectangle: rendered as a div so rounded corners stay uniform in px.
  if (el.variante === "retangulo") {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
          background: fill,
          border: sw > 0 ? `${sw}px solid ${stroke}` : "none",
          borderRadius: `${Number(s.cornerRadius) || 0}px`,
          filter,
          pointerEvents: "none",
        }}
      />
    );
  }

  const common = {
    fill,
    stroke: sw > 0 ? stroke : "none",
    strokeWidth: sw,
    vectorEffect: "non-scaling-stroke",
    strokeLinejoin: "round",
  };
  let shape;
  if (el.variante === "triangulo") {
    shape = <polygon points="50,4 96,96 4,96" {...common} />;
  } else if (el.variante === "estrela") {
    shape = <polygon points={STAR} {...common} />;
  } else if (el.variante === "losango") {
    shape = <polygon points={DIAMOND} {...common} />;
  } else {
    shape = <ellipse cx="50" cy="50" rx="48" ry="48" {...common} />;
  }
  return (
    <svg
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      width="100%"
      height="100%"
      style={{ overflow: "visible", display: "block", pointerEvents: "none", filter }}
    >
      {shape}
    </svg>
  );
}
